module.exports = __webpack_public_path__ + "static/media/10.4b445219.svg";